import Navbar from "@/components/Navbar"
import Hero from "@/components/Hero"
import Vantagens from "@/components/Vantagens"
import Galeria from "@/components/Galeria"
import ParaQuem from "@/components/ParaQuem"
import CtaFinal from "@/components/CtaFinal"
import Footer from "@/components/Footer"

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Vantagens />
      <Galeria />
      <ParaQuem />
      <CtaFinal />
      <Footer />
    </div>
  )
}

export default App